module.exports = __webpack_public_path__ + "media/images/front/brands/signature/signature_header-c9ab030e830de94631a17cd49b3f1449.webp";